import { type DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { type Dispatch } from "redux"
import { fetchAllCostCenters } from "~Shared/store/actions/costCenter/costCenterActions"
import { refetchTable } from "~Shared/store/actions/tables/tableActions"
import { TablesEnum } from "~Shared/store/reducers/tableConfigReducer"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"

export const subscribeToCostCenter = async (dispatch: Dispatch<any>, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data

    try {
        // Use the list endpoint (no per-document FETCH authz) so roles without CC1__ALL__READ
        // still get newly created cost centers — syncOne → GET /costcenters/:id returns 403 for them.
        if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.UPDATE || operationType === OperationTypeEnum.DELETE) {
            await dispatch(fetchAllCostCenters())
            dispatch(refetchTable(TablesEnum.COST_CENTERS))
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Cost Center Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
